import script from "./VIconSvg.vue?vue&type=script&setup=true&lang=ts"
export * from "./VIconSvg.vue?vue&type=script&setup=true&lang=ts"

import "./VIconSvg.vue?vue&type=style&index=0&id=4f2ce644&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2ce644"]])

export default __exports__